import getPartnerFulfilsFulfilmentStrings from "../../../getPartnerFulfilsFulfilmentStrings";

const getPartnerFulfilsA11yFulfilmentString = ({ seller }) => {
  const { dtc_seller_info_label, sellerDescription } =
    getPartnerFulfilsFulfilmentStrings({ seller });

  return `${dtc_seller_info_label} ${sellerDescription}`;
};

export default getPartnerFulfilsA11yFulfilmentString;
